import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useKeycloak } from "src/contexts/KeycloakContext";

const PrivateRoute = ({ children }:any) => {
  const { initialized, authenticated } = useKeycloak();

  if (!initialized) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/login" replace />;

  return children ? children : <Outlet/>;
};

export default PrivateRoute;